import { gql } from '@apollo/client'

// The operation name must exactly equal the root query field name: the export endpoint resolves it
// against the schema's Query type and 500s on anything else (bugs 37321, 39141).
export const EXPORT_END_OF_LIFE_QUERY = gql`
  query EndOfLife(
    $first: Int
    $after: String
    $where: EndOfLifeGraphQlFilterInput
    $order: [EndOfLifeGraphQlSortInput!]
  ) {
    endOfLife(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        countryName
        countryISOCode
        productTaxonomyLevel
        productId
        productName
        recyclingRates
        secondaryDataReferenceSourceType
        referencesSamplingYear
        referenceDataPublicationYear
        referenceRegionIdentifier
        dataQualityComment
        dataQualityReliabilityScore
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verifiedOn
        verifiedByName
        lastUpdatedName
        updated
      }
    }
  }
`
